import { render } from "./OrganizationList.vue?vue&type=template&id=64801945&ts=true"
import script from "./OrganizationList.vue?vue&type=script&lang=ts"
export * from "./OrganizationList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__